import { defineMessages } from "react-intl";

import { node as cardiology } from "src/modules/ktx/forms/transplantation-screening/cardiology";
import { node as consultations } from "src/modules/ktx/forms/transplantation-screening/consultations";
import { node as imagingProcedures } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures";
import { node as labProcedures } from "src/modules/ktx/forms/transplantation-screening/lab-procedures";
import { node as medicalHistory } from "src/modules/ktx/forms/transplantation-screening/medical-history";
import { node as tumourResearch } from "src/modules/ktx/forms/transplantation-screening/tumour-research";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.transplantation_screening",
		defaultMessage: "Transzplantációs kivizsgálás"
	}
});

export const node: ParentNode = {
	id: "ktx-transplantation-screening",
	value: { type: "wizard", title: messages.title },
	children: [
		medicalHistory,
		cardiology,
		labProcedures,
		imagingProcedures,
		tumourResearch,
		consultations
	]
};
